import React, { useEffect, useState } from "react";
import YuJaButton from "../../components/standardization/YuJaButton";
import { ReactComponent as YuJaLogo } from "../../images/yujalogo.svg";
import { MOBILE_APP_STORE_URL, MOBILE_PLAY_STORE_URL} from "../../utils/constants";
import styles from "./Login.module.css";
import { osName } from "react-device-detect";
import { useHistory} from "react-router-dom";
import { useTranslation } from "react-i18next";


export default function CreatorWarning() {
    const { t } = useTranslation();
    const history = useHistory();

    const redirectDashboard = () => {
        history.push('/home');
    }

    return (
        <div style={{backgroundColor: "#fcfbff", height: "100%", width: "100%", padding: "20px"}}> 
        <div className={styles.title} style={{fontSize: 25, lineHeight: 1.4, color: "#000000", marginBottom: "30px", marginTop: "5%"}}><YuJaLogo style={{marginRight: "15px"}}/>{t("common.appName")}</div>
        <div style={{display: "flex", justifyContent: "center", fontSize: 20, lineHeight: 1.4, fontWeight: 700, textAlign: "center"}}> {t("mobileApp.optimizeExperienceTitle")} </div>
        <div style={{display: "flex", justifyContent: "center", fontSize: 14, lineHeight: 1.6, marginTop: '20px', marginBottom: "20px", textAlign: "center"}} > {t("mobileApp.downloadAppMessage")} </div>
        <div className="app-download-buttons" style={{display: "flex", justifyContent: "center"}}>
                        {osName.match(/(iOS|Mac OS|iPad OS)/) ? 
                            <a href={MOBILE_APP_STORE_URL}>
                                <img
                                    src="https://developer.apple.com/app-store/marketing/guidelines/images/badge-download-on-the-app-store.svg"
                                    alt={t("auth.downloadOnAppStore")}
                                    height={55}
                                />
                            </a> :
                            <a href={MOBILE_PLAY_STORE_URL}>
                                <img
                                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                                    alt={t("auth.getItOnGooglePlay")}
                                    height={85}
                                />
                            </a>
                        }
                    </div>
                <div className="or-line">
                  {t("common.or")}
                </div>

                <div style={{display: "flex", justifyContent: "center"}}> <YuJaButton style={{width: '100%', padding: '15px', backgroundColor: "#42296E", color: "#FFF", fontSize: "18px", maxWidth: "450px"}} onClick={()=> {redirectDashboard()}}> {t("auth.continueInBrowser")}</YuJaButton></div>
        </div>
    )

}